import * as ActionTypes from 'state/types'

export const registerRequest = requestKey => ({
  type: ActionTypes.REQUEST_REGISTER,
  payload: {
    requestKey
  }
})

export const unregisterRequest = requestKey => ({
  type: ActionTypes.REQUEST_UNREGISTER,
  payload: {
    requestKey
  }
})
